import { useEffect, useLayoutEffect, useMemo, useSyncExternalStore } from 'react';
import {
  observationPositionKey,
  type GameReplayState,
  type GameReplayStore,
  type ObservationAnalysisPosition,
} from '../stores/game-replay-store';
import { ObservationAiSession, presentObservationAi } from '../stores/observation-ai-session';

export function useObservationAi({
  gameId,
  position,
  suspended,
  replayStore,
  replayState,
}: {
  gameId: string;
  position: ObservationAnalysisPosition | null;
  suspended: boolean;
  replayStore: GameReplayStore | undefined;
  replayState: GameReplayState | null;
}) {
  const session = useMemo(() => new ObservationAiSession(replayStore), [replayStore]);
  const state = useSyncExternalStore(session.subscribe, session.snapshot, session.snapshot);
  const key = position === null ? null : observationPositionKey(position);
  useLayoutEffect(() => {
    session.setContext(gameId, position, suspended);
  }, [session, gameId, key, suspended]);
  useEffect(() => () => session.stop(), [session]);

  return {
    ...presentObservationAi(state, gameId, position, suspended, replayState),
    toggle: session.toggle,
    retry: session.retry,
    stop: session.stop,
  };
}
